import React, { useState } from 'react';
import { DeleteDocuments } from './DeleteDocuments';
import { Transition } from 'react-transition-group';
import { MyDocumentsApi } from '../../api/myDocumentsApi';
import { UploadDocuments } from './UploadDocuments';
import { EditFolder } from './EditFolder';
import { DeleteFolders } from './DeleteFolder';
import { useDispatch } from 'react-redux';
import { setMyDocumentsListParentFolder } from 'reducers/misc';
import { DeleteAll } from './DeleteAll';
import { MoveFilesAndFolders } from './MoveFilesAndFolders';

export const MyDocumentsMenuOptions: React.FC<any> = (props) => {
  const dispatch = useDispatch();
  const [openDeletePopup, setOpenDeletePopup] = useState<boolean>(false);
  const [openUploadDocumentPopup, setOpenUploadDocumentPopup] =
    useState<boolean>(false);
  const [openEditFolderPopup, setOpenEditFolderPopup] =
    useState<boolean>(false);
  const [openMovePopup, setOpenMovePopup] = useState<boolean>(false);

  let isAllFiles =
    props.selectedItemsList &&
    props.selectedItemsList.every((item: any) => item.documents__id !== null);
  let isAllFolders =
    props.selectedItemsList &&
    props.selectedItemsList.every((item: any) => item.folders__id !== null);
  let isFilesAndFolders =
    props.selectedItemsList && !isAllFiles && !isAllFolders;
  let itemNames =
    props.selectedItemsList &&
    props.selectedItemsList.map((item: any) => item.list__itemname);

  return (
    <Transition
      in={props.openCloseState?.toLowerCase() === 'open'}
      timeout={0}
      mountOnEnter
    >
      {(transitionState) => (
        <div className={`RightMenu ${props.openCloseState} ` + transitionState}>
          {props.checkboxList && props.checkboxList.length > 0 && (
            <div className="ItemsContainer">
              {/* View document 
              {isAllFiles && props.checkboxList.length === 1 && (
                <div
                  className="Item"
                  onClick={() =>
                    MyDocumentsApi.viewFile(
                      props.checkboxList[0],
                      props.selectedItemsList[0].list__itemname
                    )
                  }
                >
                  <span>View File</span>
                </div>
              )*/}

              {/* Update document */}
              {isAllFiles && props.checkboxList.length === 1 && (
                <div
                  className="Item"
                  onClick={() => setOpenUploadDocumentPopup(true)}
                >
                  <span>Update File</span>
                </div>
              )}

              {/* View folder *
              {isAllFolders && props.checkboxList.length === 1 && (
                <div
                  className="Item"
                  onClick={() => {
                    dispatch(
                      setMyDocumentsListParentFolder({
                        parentsFolderId: props.selectedItemsList[0].folders__id,
                        parentsFolderName:
                          props.selectedItemsList[0].list__itemname,
                      })
                    );
                  }}
                >
                  <span>Open Folder</span>
                </div>
              )*/}

              {/* Update folder */}
              {isAllFolders && props.checkboxList.length === 1 && (
                <div
                  className="Item"
                  onClick={() => {
                    setOpenEditFolderPopup(true);
                  }}
                >
                  <span>Update Folder</span>
                </div>
              )}

              {/* Move file/folder */}
              {props.checkboxList.length === 1 && (
                <div
                  className="Item"
                  onClick={() => {
                    setOpenMovePopup(true);
                  }}
                >
                  <span>{isAllFiles ? 'Move File' : 'Move Folder'}</span>
                </div>
              )}

              {/* Delete file(s) */}
              {isAllFiles && (
                <div className="Item" onClick={() => setOpenDeletePopup(true)}>
                  <span>
                    Delete File
                    {props.checkboxList && props.checkboxList.length > 1
                      ? 's'
                      : ''}
                  </span>
                </div>
              )}

              {/* Delete folders */}
              {isAllFolders && props.checkboxList.length > 0 && (
                <div
                  className="Item"
                  onClick={() => {
                    setOpenDeletePopup(true);
                  }}
                >
                  <span>{`Delete ${
                    props.checkboxList.length > 1 ? 'Folders' : 'Folder'
                  }`}</span>
                </div>
              )}

              {/* Delete All */}
              {!isAllFolders &&
                !isAllFiles &&
                props.checkboxList.length > 0 && (
                  <div
                    className="Item"
                    onClick={() => {
                      setOpenDeletePopup(true);
                    }}
                  >
                    <span>{`Delete ${
                      props.checkboxList.length > 1
                        ? 'Folders/Files'
                        : 'Folder/File'
                    }`}</span>
                  </div>
                )}

              {/* Delete Pop-up  */}
              {isAllFiles && openDeletePopup && (
                <DeleteDocuments
                  panelOpen={openDeletePopup}
                  togglePanelOpen={setOpenDeletePopup}
                  addPluralTxt={
                    props.checkboxList && props.checkboxList.length > 1
                  }
                  ids={props.checkboxList}
                  fileType={[isAllFiles, isAllFolders, isFilesAndFolders]}
                  itemNames={itemNames}
                />
              )}

              {/* Edit Document Pop-up  */}
              {openUploadDocumentPopup && (
                <UploadDocuments
                  panelOpen={openUploadDocumentPopup}
                  togglePanelOpen={setOpenUploadDocumentPopup}
                  selectedFileId={props.checkboxList[0]}
                />
              )}

              {/* Edit Folder Pop-up  */}
              {isAllFolders && openEditFolderPopup && (
                <EditFolder
                  panelOpen={openEditFolderPopup}
                  togglePanelOpen={setOpenEditFolderPopup}
                  selectedId={props.checkboxList[0]}
                />
              )}

              {/* Delete Folders Pop-up  */}
              {isAllFolders && openDeletePopup && (
                <DeleteFolders
                  panelOpen={openDeletePopup}
                  togglePanelOpen={setOpenDeletePopup}
                  addPluralTxt={
                    props.checkboxList && props.checkboxList.length > 1
                  }
                  ids={props.checkboxList}
                  selectedData={props.selectedItemsList}
                />
              )}
              {/* Delete  Pop-up  */}
              {!isAllFolders && !isAllFiles && openDeletePopup && (
                <DeleteAll
                  panelOpen={openDeletePopup}
                  togglePanelOpen={setOpenDeletePopup}
                  selectedData={props.selectedItemsList}
                />
              )}
              {openMovePopup && (
                <MoveFilesAndFolders
                  panelOpen={openMovePopup}
                  togglePanelOpen={setOpenMovePopup}
                  selectedId={props.checkboxList[0]}
                  isAllFiles={isAllFiles}
                />
              )}
            </div>
          )}
        </div>
      )}
    </Transition>
  );
};
